import { Trans, Plural } from '@lingui/react/macro';
import { Button } from '@pantry/ui';
import { ClockIcon, XMarkIcon } from '@heroicons/react/24/outline';

interface ResumeDraftBannerProps {
  itemCount: number;
  onResume: () => void;
  onDiscard: () => void;
}

/**
 * Banner shown when there's a pending draft from a previous session.
 * Offers to resume or discard the draft.
 */
export function ResumeDraftBanner({ itemCount, onResume, onDiscard }: ResumeDraftBannerProps) {
  return (
    <div className="bg-primary/5 border border-primary/20 rounded-xl p-4 animate-in fade-in slide-in-from-top-2 duration-300">
      <div className="flex items-start gap-3">
        <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-primary/10">
          <ClockIcon className="h-5 w-5 text-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-display text-sm font-semibold text-foreground">
            <Trans>Resume previous batch?</Trans>
          </p>
          <p className="text-sm text-muted-foreground mt-0.5">
            <Plural
              value={itemCount}
              one="You have # unsaved item from a previous session."
              other="You have # unsaved items from a previous session."
            />
          </p>
          <div className="flex gap-2 mt-3">
            <Button size="sm" className="rounded-lg" onClick={onResume}>
              <Trans>Resume Draft</Trans>
            </Button>
            <Button
              variant="ghost"
              size="sm"
              className="rounded-lg text-muted-foreground hover:text-foreground"
              onClick={onDiscard}
            >
              <XMarkIcon className="h-4 w-4 mr-1" />
              <Trans>Discard</Trans>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
